/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{text-align:center}\n/*# sourceMappingURL=scale-chart.component.css.map*/"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/assessment-charts/scale-chart/scale-chart.component.css.shim.ngstyle.js.pre-build-optimizer.js